import { Routes, Route } from "react-router-dom";
import AdminLayout from "../components/AdminLayout";
import Dashboard from "../pages/Dashboard";
import AdminProtectedRoute from "../../auth/AdminProtectedRoute";
import PlaceholderPage from "../pages/PlaceholderPage";
import SubscriptionPlansManagement from "../pages/SubscriptionPlansManagement";
import AdminTimetablePage from "../pages/AdminTimetablePage";
import SessionBookingPage from "../pages/SessionBookingPage";
import AdminUserPage from "../pages/AdminUserPage";
import AdminUserDetails from "../components/users/AdminUserDetails";
import AdminSpeakerPage from "../pages/AdminSpeakerPage";
import AgendaPage from "../components/session_agenda/AgendaPage";
import AgendaItemPage from "../components/session_agenda/AgendaItemPage";
import AdminSupport from "../pages/AdminSupport";
import AdminReviewsPage from "../components/customer_reviews/AdminReviewsPage";
import AdminDatabaseBackup from "../db_backup/AdminDatabaseBackup";
import SessionCustomersPage from "../components/time_table/SessionCustomersPage";
import EmailCampaignPage from "../email/EmailCampaignPage";
import PaymentDashboard from "../components/payments/PaymentDashboard";
import AdminAnnouncementPage from "../announcement/AdminAnnouncementPage";
import AdminManualTasksPage from "../manual_tasks/AdminManualTasksPage";
import AdminEventPage from "../events/AdminEventPage";
import AdminEventUsersPage from "../events/AdminEventUsersPage";
import GooglePlanListPage from "../components/plans/GooglePlanListPage";
import GooglePlanFormPage from "../components/plans/GooglePlanFormPage";
import AdminAppUpdatePage from "../appUpdate/AdminAppUpdatePage";
import AdminAccountDeletionPage from "../accountHandling/AdminAccountDeletionPage";
import AdminFaqPage from "../components/faq/AdminFaqPage";
import AdminTongueTwisterPage from "../blog/AdminTongueTwisterPage";

const AdminRoutes = () => {
  return (
    <Routes>
      {/* ===============================
         PROTECTED ADMIN ROUTES
      =============================== */}
      <Route
        element={
          <AdminProtectedRoute>
            <AdminLayout />
          </AdminProtectedRoute>
        }
      >
        {/* Dashboard */}
        <Route index element={<Dashboard />} />

        {/* Placeholder pages (Phase-wise rollout) */}
        <Route
          path="users"
          element={<AdminUserPage title="Users Management" />}
        />

        <Route
          path="users/:id"
          element={<AdminUserDetails />}
        />

        <Route
          path="admin_speakers"
          element={<AdminSpeakerPage title="Admin Speakers" />} 
        />
        <Route
          path="session_agendas/:sessionId"
          element={<AgendaPage />}
        />

       <Route path="agenda-items/:agendaId" element={<AgendaItemPage />} />

        <Route
          path="subscription_plans"
          element={<SubscriptionPlansManagement title="Subscription Plans" />} 
        />

         <Route
          path="admin_time_table"
          element={<AdminTimetablePage title="Time Table" />} 
        />

        <Route
          path="admin_session_booking"
          element={<SessionBookingPage title="Session Booking" />} 
        />

        <Route
          path="analytics"
          element={<PlaceholderPage title="Analytics Overview" />}
        />

        {/* Future Admin Widgets (Direct links if needed) */}
        <Route
          path="revenue-by-plan"
          element={<PlaceholderPage title="Revenue by Plan" />}
        />
        <Route
          path="monthly-revenue"
          element={<PlaceholderPage title="Monthly Revenue" />}
        />
        <Route
          path="user-growth"
          element={<PlaceholderPage title="User Growth" />}
        />
        <Route
          path="free-to-paid"
          element={<PlaceholderPage title="Free → Paid Conversion" />}
        />
          <Route
          path="admin-support"
          element={<AdminSupport title="Admin Support" />}
        />

         <Route
          path="admin-user-review"
          element={<AdminReviewsPage title="User Reviews" />}
        />

         <Route
          path="admin-db-backup"
          element={<AdminDatabaseBackup title="Database backup" />}
        />

         <Route
          path="sessions/:sessionId/customers"
          element={<SessionCustomersPage />}
         />


         <Route
          path="email-campaign-page"
          element={<EmailCampaignPage title="Email Campaign" />}
        />

        <Route
          path="admin-payment-dashboard"
          element={<PaymentDashboard title="Payment Dashboard" />}
        />

        <Route
          path="admin-announcement"
          element={<AdminAnnouncementPage title="Announcement" />}
        />

         <Route
          path="admin-manual-task"
          element={<AdminManualTasksPage title="Manual task" />}
        />

        <Route
          path="admin-events"
          element={<AdminEventPage title="Events" />}
        />
        
       <Route
        path="admin-events/:eventId/users"
        element={<AdminEventUsersPage />}
       />

      <Route
      path="google-plans/:planId"
       element={<GooglePlanListPage />}
   />

     <Route
     path="google-plans/:planId/create"
     element={<GooglePlanFormPage />}
   />

    <Route
     path="google-plans/:planId/edit/:googlePlanId"
     element={<GooglePlanFormPage />}
    />
    
     <Route
          path="admin-app-update"
          element={<AdminAppUpdatePage title="App updates" />}
        />

      </Route>

      <Route
          path="admin-account-handling"
          element={<AdminAccountDeletionPage title="App updates" />}
        />

         <Route
          path="admin-faq"
          element={<AdminFaqPage title="Admin FAQ" />}
        />

         <Route
          path="admin-tongue-twister"
          element={<AdminTongueTwisterPage title="Admin Tongue Twister" />}
        />

    </Routes>
  );
};

export default AdminRoutes;
